import { AxiosInstance } from 'axios';
import { User } from './types';

export function usersApi(client: AxiosInstance) {
  return {
    getList: (page: number, pageSize: number) =>
      client.post<{ items: User[]; total: number }>('/api/v1/admin/users/get-list', { page, pageSize }),
    deleteUser: (userId: number) =>
      client.post<void>('/api/v1/admin/users/delete', { userId }),
  };
}
